import { MdOutlineDiscount } from "react-icons/md";

import AlertTooltip from "@/components/AlertTooltip";

const ErrorBadge = ({ row }: { row: any }) => {
  return (
    <div className="flex w-fit text-center">
      {row.consortia_size === 0 && (
        <AlertTooltip message="Cliente sem SPE vinculada (Configure a carta de Rateio)" />
      )}

      {/* TODO: Não funciona já que não passa no serializer, esperando SWI-771 */}
      {row.active_discount === 0 && (
        <MdOutlineDiscount
          color="#FFA726"
          title="Cliente sem desconto ativo"
          style={{ marginLeft: 4, verticalAlign: "middle" }}
          size={18}
        />
      )}
    </div>
  );
};

export default ErrorBadge;
